import { render, staticRenderFns } from "./b-popup-customer-follow-up-detail.vue?vue&type=template&id=a64daf32&scoped=true"
import script from "./b-popup-customer-follow-up-detail.vue?vue&type=script&lang=js"
export * from "./b-popup-customer-follow-up-detail.vue?vue&type=script&lang=js"
import style0 from "./b-popup-customer-follow-up-detail.vue?vue&type=style&index=0&id=a64daf32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64daf32",
  null
  
)

export default component.exports